import { React, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import FetchModule from '../../../Share/Network/FetchModule';

import MemberShipHistoryInfoButtonImagePath from '../../../../image/MemberShipHistoryInfoButton.png';

const FirstCourseHistoryInfoView = (props) => {
  const { data, isOver, reserveRerendering  } = props;

	const history = useHistory();

  const [isClicked, setIsClicked] = useState(false);
  const [state, setState] = useState('예약중');
  const [isAvailableExit, setIsAvailableExit] = useState(false);
  const [isAbsent, setIsAbsent] = useState(false);
  const [isLate, setIsLate] = useState(false);
  const [isAttendance, setIsAttendance] = useState(false);

  const OptionBoxRef = useRef();
  const OptionButtonRef = useRef();

  useEffect(() => {
    if (isClicked) {
      // if (isOver) OptionBoxRef.current.style.height = `180px`;
      if (isOver) OptionBoxRef.current.style.height = `144px`;
      // else OptionBoxRef.current.style.height = `130px`;
      else OptionBoxRef.current.style.height = `144px`;
      OptionBoxRef.current.style.border = `1px solid #FF8B48`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid #FF8B48`;
    }
  }, [isClicked, isOver])

  useEffect(() => {
    if (data.status === 0) {
      // console.log(data.classDate.split('T')[0] + data.classTime.split('-')[0] + ':00')
      // console.log(moment().format('YYYY-MM-DDTHH:mm:ss'))
      // console.log(moment(data.classDate.split('T')[0] + "T" + data.classTime.split('-')[0] + ':00').isAfter(moment()));
      if (moment(data.classDate.split('T')[0] + "T" + data.classTime.split('-')[0] + ':00').isAfter(moment())) {
        setState('예약중');
        setIsAvailableExit(true);
        setIsAbsent(true);
        setIsLate(true);
        setIsAttendance(true);
      }
      else {
        setState('결석');
        setIsAvailableExit(false);
        setIsAbsent(false);
        setIsLate(true);
        setIsAttendance(true);
      }
    }
    else if (data.status === 1) {
      setState('출석');
      setIsAvailableExit(false);
      setIsAbsent(true);
      setIsLate(true);
      setIsAttendance(false);
    }
    else if (data.status === 2) {
      setState('지각');
      setIsAvailableExit(false);
      setIsAbsent(true);
      setIsLate(false);
      setIsAttendance(true);
    }
    else if (data.status === 3) {
      setState('결석');
      setIsAvailableExit(false);
      setIsAbsent(false);
      setIsLate(true);
      setIsAttendance(true);
    }
  }, [data])
  
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  function onClickOutSide(e) {
    if (OptionBoxRef.current !== e.target && OptionButtonRef.current !== e.target) {
      setIsClicked(false);
    }
  }

  function mouseOver() {
    OptionButtonRef.current.style.opacity = 1;
  }

  function mouseLeave() {
    OptionButtonRef.current.style.opacity = 0;
  }

  function onClickChangeState(state) {
    if (!isAttendance && state === 1) return;
    else if (!isLate && state === 2) return;
    else if (!isAbsent && state === 3) return;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('reserve/modify/' + data.id + '/' + state, 'POST');
     
        if (responseData.status === 200) reserveRerendering();
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }

  function onClickDeleteLessonReservation() {
    if (!isAvailableExit) return;
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('reserve/delete/manage/' + data.id, 'POST');
        
        if (responseData.status === 200) reserveRerendering();
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }

  return (
    <TopLevelWrapper isOver={isOver} onMouseOver={mouseOver} onMouseLeave={mouseLeave}>
      {
        isOver ?
          <Table>
            <Body isOver={isOver}>
              <Tr>
                <Td style={{ width: 'max(53px, 6.1vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(23px, 2.994791666666667vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.id}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(89px, 10.4vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(61px, 7.942708333333333vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.classDate.replaceAll('-', '.').slice(2, 10)}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(244px, 30.5vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(244px, 30.5vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.lessonName}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(210px, 27.34375vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(58px, 7.552083333333333vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.classTime.slice(0, 5)}</Text>
                  </TextWrapper>
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <OptionButton ref={OptionButtonRef} src={MemberShipHistoryInfoButtonImagePath} isOver={isOver} onClick={() => setIsClicked(!isClicked)} />
                  <OptionWrapper ref={OptionBoxRef} isOver={isOver}>
                    {/* <Option>예약중</Option> */}
                    <Option isAvailable={isAvailableExit} onMouseDown={onClickDeleteLessonReservation}>예약 취소</Option>
                    <Option isAvailable={isAttendance} onMouseDown={() => onClickChangeState(1)}>출석 처리</Option>
                    <Option isAvailable={isLate} onMouseDown={() => onClickChangeState(2)}>지각 처리</Option>
                    <Option isAvailable={isAbsent} onMouseDown={() => onClickChangeState(3)}>결석 처리</Option>
                  </OptionWrapper>
                </Td>
              </Tr>
            </Body>
          </Table>
          :
          <Table>
            <Body isOver={isOver}>
              <Tr>
                <Td style={{ width: 'max(41px, 12vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(41px, 12vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.id}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(52px, 15.8vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(53px, 15.8vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.classDate.replaceAll('-', '.').slice(2, 10)}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(62px, 18vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(62px, 18vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.lessonName}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(65px, 20.3125vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(65px, 20.3125vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.classTime.slice(0, 5)}</Text>
                  </TextWrapper>
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <OptionButton ref={OptionButtonRef} src={MemberShipHistoryInfoButtonImagePath} isOver={isOver} onClick={() => setIsClicked(!isClicked)} />
                  <OptionWrapper ref={OptionBoxRef} isOver={isOver}>
                    {/* <Option>예약중</Option> */}
                    <Option isAvailable={isAvailableExit} onMouseDown={onClickDeleteLessonReservation}>예약 취소</Option>
                    <Option isAvailable={isAttendance} onMouseDown={() => onClickChangeState(1)}>출석 처리</Option>
                    <Option isAvailable={isLate} onMouseDown={() => onClickChangeState(2)}>지각 처리</Option>
                    <Option isAvailable={isAbsent} onMouseDown={() => onClickChangeState(3)}>결석 처리</Option>
                  </OptionWrapper>
                </Td>
              </Tr>
            </Body>
          </Table>
      }
    </TopLevelWrapper>
  )
};

export default FirstCourseHistoryInfoView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: ${props => props.isOver ? `max(690px, 89.84375vw)` : `max(280px, 87.5vw)`};
  height: ${props => props.isOver ? `50px` : `17px`};

  background: #FFFFFF;

  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  border: 1px solid #FFFFFF;
  border-radius: 30px;
  
  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid #FF8B48;
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;
  
  margin-left: ${props => props.isOver ? `max(28px, 3.645833333333333vw)` : `max(10px, 3.125vw)`};

  width: ${props => props.isOver ? `max(640px, 83.33333333333333vw)` : `max(262px, 81.875vw)`};
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;

  padding: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: ${props => props.isOver ? `20px` : `15px`};
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: ${props => props.isOver ? `14px` : `10px`};

  color: #595959;

  margin: 0 0 0 0;
  padding: 0 0 0 0;
  
  -webkit-transform: ${props => props.isOver ? `scale(1)` : `scale(0.9)`};
`;

const OptionButton = styled.img`
  width: ${props => props.isOver ? `20px` : `9px`};
  height: ${props => props.isOver ? `20px` : `9px`};

  opacity: 0;
  
  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  overflow: hidden;

  height: 0px;

  z-index: 5;

  margin-top: ${props => props.isOver ? `40px` : `16px`};
  margin-left: ${props => props.isOver ? `-20px` : `-42px`};

  border: 0px solid #FF8B48;
  border-radius: 8px;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `78px` : `58px`};
  height: ${props => props.isOver ? `36px` : `26px`};

  font-family: NotoSansKR-Regular;
  font-size: ${props => props.isOver ? `14px` : `10px`};

  color: ${props => props.isAvailable ? `#FF8B48` : `#CBCBCB`};
  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: ${props => props.isAvailable ? `#FFFFFF` : `#CBCBCB`};
    background-color: #FF8B48;
  }
`;